import Icon from '@/app/components/Icon';
import {
  handleChatMenu,
  handleChatPopup,
} from '@/redux/reducers/chat-link-reducer';
import { cn } from '@/utils/cn';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

function ChatFloatingButton() {
  const dispatch = useDispatch();
  const { openChatMenu, openChatPopup } = useSelector(
    (state) => state.chatLink,
  );

  const chatPopupHandler = (e) => {
    e.stopPropagation();
    dispatch(handleChatPopup());
  };

  const chatMenuHandler = (e) => {
    e.stopPropagation();
    dispatch(handleChatMenu());
  };

  return (
    <div
      className={cn(
        'container bg-white sm:rounded-xl rounded-xl flex flex-col justify-between fixed bottom-[88px] right-4 lg:right-[60px] lg:bottom-[60px] h-[60px] w-[48px] lg:h-[72px] lg:w-[56px] p-[4px] z-50 shadow-md',
        {
          block: !openChatMenu && openChatPopup,
          hidden: !openChatPopup || openChatMenu,
        },
      )}
    >
      <div className="flex justify-end items-start">
        <div className="flex justify-end items-center w-[40px] h-[20px] lg:w-[48px] lg:h-[28px]">
          <Icon
            type="close"
            color="#49525E"
            className="cursor-pointer w-[20px] h-[20px]"
            onClick={(e) => chatPopupHandler(e)}
          />
        </div>
      </div>
      <div className="flex items-center justify-center">
        <div
          role="presentation"
          onClick={(e) => chatMenuHandler(e)}
          className="flex justify-center items-start w-[40px] h-[40px] lg:w-[48px] lg:h-[48px]"
        >
          <div className="relative w-[24px] h-[24px] lg:w-[32px] lg:h-[32px]">
            <Icon
              type="ChatMenuIcon"
              className="size-[24px] lg:size-[32px] cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatFloatingButton;
